import _ from "lodash"
import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import withRouter from "components/Common/withRouter"

import {
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap"
import Select from "react-select"

//Import selects arrays
import { getResidencyLength, getStates, getResidencyStatus } from "common/selects"

//Import functions
import { USDFormat } from "common/global/functions"

import PreviousAddressForm from "./_partials/previousAddressForm"

const ResidencyInformationForm = ({
  initialValues,
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  submitForm,
  setFieldValue,
  setFieldTouched,
  setFieldError,
  handleSelectChange,
  ...props
}) => {

    const [selectedResidenceLengthValue, setSelectedResidenceLengthValue] = useState(values.residence_length);

  const handleCurrencyFormat = e => {
    if(/^\d+(\.\d+)?$/.test(e.target.value))
    setFieldValue(e.target.name, Number(e.target.value).toFixed(2))

    handleBlur(e);
  }

  return (
    <React.Fragment>
      <Form className="form-horizontal" id="residency-information-form">
        <Input
            type="hidden"
            id="key"
            name="key"
            value={values.key || ""}
            invalid={errors.key ? true : false}
        />
        {touched.key && errors.key && (
            <FormFeedback
            className="mb-3"
            type="invalid"
            style={{ fontSize: "100%" }}
            >
            {errors.key}
            </FormFeedback>
        )}
        <Row>
          <Col lg="6">
            <FormGroup className="mb-3">
                <Label for="residence_length">
                    How Long at present address
                </Label>
                <Select
                    id="residence_length"
                    name="residence_length"
                    placeholder="Select Residency Length"
                    defaultValue={selectedResidenceLengthValue}
                    value={selectedResidenceLengthValue}
                    onChange={selectedOption => {
                        let event = {
                        target: {
                            name: "residence_length",
                            option: selectedOption,
                        },
                        }
                        handleSelectChange(event)
                    }}
                    isSearchable={true}
                    options={getResidencyLength()}
                    isLoading={false}
                    loadingMessage={() =>
                        "loading homeownership length"
                    }
                    noOptionsMessage={() => "residence_length"}
                    invalid={
                        touched.residence_length &&
                        errors.residence_length &&
                        errors.residence_length.value
                        ? true
                        : false
                    }
                />
                {touched.residence_length &&
                errors.residence_length &&
                errors.residence_length.value && (
                    <FormFeedback
                        type="invalid"
                        style={{
                        display: "block",
                        fontSize: "100%",
                        }}
                    >
                        {errors.residence_length.value}
                    </FormFeedback>
                )}
            </FormGroup>
          </Col>
          <Col lg="6">
            <FormGroup className="mb-3">
            <Label for="homeownershipid">
                Residency Status
                </Label>
                <Select
                id="homeownershipid"
                name="homeownershipid"
                placeholder="Select Residency Status"
                defaultValue={
                    values.homeownershipid
                }
                onChange={selectedOption => {
                    let event = {
                    target: {
                        name: "homeownershipid",
                        option: selectedOption,
                    },
                    }
                    handleSelectChange(event)
                }}
                isSearchable={true}
                options={getResidencyStatus()}
                isLoading={false}
                loadingMessage={() =>
                    "loading homeownership types"
                }
                noOptionsMessage={() => "homeownershipid"}
                invalid={
                    touched.homeownershipid &&
                    errors.homeownershipid &&
                    errors.homeownershipid.value
                    ? true
                    : false
                }
                />
                {touched.homeownershipid &&
                errors.homeownershipid &&
                errors.homeownershipid.value && (
                <FormFeedback
                    type="invalid"
                    style={{
                    display: "block",
                    fontSize: "100%",
                    }}
                >
                    {errors.homeownershipid.value}
                </FormFeedback>
                )}
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col lg="6">
            <FormGroup className="mb-3">
                <Label for="mortgage">
                    Mortgage/Rent payment
                </Label>
                <Input
                    type="text"
                    className="form-control"
                    id="mortgage"
                    name="mortgage"
                    placeholder="Enter Applicant Mortgage/Rent Payment (Monthly)"
                    onChange={handleChange}
                    onBlur={handleCurrencyFormat}
                    value={
                        values.mortgage || ""
                    }
                    invalid={
                        touched.mortgage &&
                        errors.mortgage
                        ? true
                        : false
                    }
                />
                {touched.mortgage && errors.mortgage && (
                    <FormFeedback
                        type="invalid"
                        style={{ fontSize: "100%" }}
                    >
                        {errors.mortgage}
                    </FormFeedback>
                )}
            </FormGroup>
          </Col>
          </Row>
                
          {/* Partial Income Description*/}
          <PreviousAddressForm
              initialValues={initialValues}
              values={values}
              errors={errors}
              touched={touched}
              getStates={getStates}
              handleChange={handleChange}
              handleBlur={handleBlur}
              handleCurrencyFormat={handleCurrencyFormat}
              selectedResidenceLengthValue={selectedResidenceLengthValue}
          />
          {/* End Partial Income Description*/}
        
      </Form>
    </React.Fragment>
  )
}

export default ResidencyInformationForm 
